import { useState } from 'react';
import { isPlayableMedia, isSafeMediaLink, openInNewTab } from '../../utils/openMedia';

/**
 * Centraliza "o que acontece ao clicar numa mídia": vídeo/áudio abrem no
 * MediaPlayerDialog, o resto (PDF, Imagem) numa nova aba.
 */
const useMediaOpener = () => {
    const [playingMedia, setPlayingMedia] = useState(null);

    const openMedia = media => {
        if (!isSafeMediaLink(media.link)) {
            console.error(`[useMediaOpener] Link de mídia inválido (id ${media.id}):`, media.link);
            return;
        }

        if (isPlayableMedia(media)) {
            setPlayingMedia(media);
            return;
        }

        openInNewTab(media.link);
    };

    const closeMedia = () => setPlayingMedia(null);

    return { playingMedia, openMedia, closeMedia };
};

export default useMediaOpener;
